import * as actionType from "./action";

const initialState = {
  user: null,
  role: null,
  token: null,
  isValidToken: true,
  userEntry: [false, "login"],
  stationId: null,
  userHaveReset: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.LOGIN:
      return {
        ...state,
        ...action.payload,
        userEntry:
          state.userEntry?.[0] && action.payload.isGuestHydration === true
            ? state.userEntry
            : [false, "login"],
        userHaveReset: false,
      };
    case actionType.UPDATE_USER:
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    case actionType.LOGOUT:
      return {
        ...state,
        stationId: null,
        user: null,
        role: null,
        userHaveReset: false,
      };
    case actionType.SET_IS_VALID_TOKEN:
      return {
        ...state,
        isValidToken: action.payload,
      };
    case actionType.UPDATE_STATION_ID:
      return {
        ...state,
        stationId: action.payload,
      };
    case actionType.USER_ENTRY:
      return {
        ...state,
        userEntry: action.payload,
      };
    case actionType.VERIFIED_EMAIL:
      return {
        ...state,
        userHaveReset: action.payload || false,
        userEntry: action.payload ? [true, "verifyEmail"] : [false, "login"],
      };
    case actionType.SET_TEMP_ADDRESS:
      return {
        ...state,
        stationId: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
